/* eslint-disable max-len */
import { SIDEBAR } from 'config/messages'

const {
  PROFILE,
  SECURITY,
  EASYTOKEN,
  PERSONAL_INFO,
  RESIDENCIAL_ADDRESS,
  BUSINESS_INFO,
  BANK_INFO,
  FINANCIAL_SITUATION,
  PASSWORD,
  BROKER_TRANSFER,
  CUSTODY_TRANSFER,
  EDUCATIONAL,
  HELP,
  ACCOUNT_STATEMENT,
  ELECTRONIC_SIGNATURE,
  DEPOSITS_AND_WITHDRAWALS,
  EXECUTE_OPERATION,
  OPERATIONS,
  REPORTS,
  LOGOUT,
  INCOME_REPORT
} = SIDEBAR

const registerPendencyItems = [HELP, LOGOUT, EDUCATIONAL]

const subItemsReports = [
  {
    title: ACCOUNT_STATEMENT,
    to: '/relatorios/extrato'
  },
  {
    title: INCOME_REPORT,
    to: '/relatorios/informe-rendimento'
  }
]

const profileSubItems = [
  {
    title: PERSONAL_INFO,
    to: '/perfil/informacoes-pessoais'
  },
  {
    title: RESIDENCIAL_ADDRESS,
    to: '/perfil/endereco-residencial'
  },
  {
    title: BUSINESS_INFO,
    to: '/perfil/dados-profissionais'
  },
  {
    title: FINANCIAL_SITUATION,
    to: '/perfil/situacao-financeira'
  }
]

const subItems = (subItemsArray, featureToggle, title) => {
  const arr = []
  subItemsArray.map(item =>
    item.title === title ? featureToggle && arr.push(item) : arr.push(item)
  )
  return arr
}

const items = (isMobile, hasFeatureToggleCustody,
  _hasFeatureToggleEarnings, allowResidentialUpdate, hasFeatureRemoveEasytoken, noTed) => [
  {
    title: REPORTS,
    to: isMobile ? '' : '/relatorios',
    subItems: subItemsReports
  },
  {
    title: DEPOSITS_AND_WITHDRAWALS,
    to: isMobile ? '' : '/depositos-e-retiradas',
    subItems: [
      {
        title: EXECUTE_OPERATION,
        to: '/depositos-e-retiradas/conta'
      },
      {
        title: BANK_INFO,
        to: '/depositos-e-retiradas/conta-bancaria'
      }
    ]
  },
  {
    title: OPERATIONS,
    to: isMobile ? '' : '/movimentacoes',
    subItems: [
      {
        title: hasFeatureToggleCustody ? CUSTODY_TRANSFER : BROKER_TRANSFER,
        to: `/movimentacoes/transferencia-de-${hasFeatureToggleCustody ? 'custodia' : 'corretora'}`
      }
    ]
  },
  {
    title: PROFILE,
    to: isMobile ? '' : '/perfil',
    subItems: subItems(profileSubItems, allowResidentialUpdate, RESIDENCIAL_ADDRESS)
  },
  {
    title: SECURITY,
    to: isMobile ? '' : '/seguranca',
    subItems: subItems([
      {
        title: PASSWORD,
        to: '/seguranca/senha'
      },
      {
        title: ELECTRONIC_SIGNATURE,
        to: '/seguranca/assinatura-eletronica'
      },
      {
        title: EASYTOKEN,
        to: '/seguranca/easytoken'
      }
    ], !hasFeatureRemoveEasytoken, EASYTOKEN)
  },
  {
    title: HELP,
    to: '/ajuda'
  },
  {
    title: LOGOUT,
    to: '/sair'
  }
].filter(item => !noTed || item.title !== DEPOSITS_AND_WITHDRAWALS)

const sidebarItems = (isMobile, hasRegisterPendency, hasFeatureToggleCustody,
  hasFeatureToggleEarnings, allowResidentialUpdate,
  hasFeatureRemoveEasytoken, noTed) => hasRegisterPendency
  ? items(isMobile, hasFeatureToggleCustody, hasFeatureToggleEarnings, allowResidentialUpdate, hasFeatureRemoveEasytoken, noTed)
    .filter(item => registerPendencyItems.indexOf(item.title) > -1)
  : items(isMobile, hasFeatureToggleCustody, hasFeatureToggleEarnings, allowResidentialUpdate, hasFeatureRemoveEasytoken, noTed)

export default sidebarItems
